import InformationBlock from "./InformationBlock";
import React from "react";
import {ReactComponent as Img} from "../../images/release/Relax.svg";
import PropTypes from "prop-types";

export default function EmptyCourseBlock({text}) {
    return <InformationBlock>
        <div className="EmptyCourseBlock-wrapper-dev">
            <Img/>
            <div>{text}</div>
        </div>
    </InformationBlock>
}

EmptyCourseBlock.propTypes = {
    text: PropTypes.string,
}